import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={10}
      height={12}
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M9.152 3.518h-.837a.18.18 0 00-.144.074L5 7.962l-3.172-4.37a.18.18 0 00-.144-.074H.848a.09.09 0 00-.072.142L4.71 9.085a.356.356 0 00.577 0L9.223 3.66a.089.089 0 00-.071-.142z"
        fill="#000"
        fillOpacity={0.85}
      />
    </Svg>
  );
}

export default SvgComponent;
